import React from 'react';
import MaterialTable, {MTableToolbar} from "material-table";
import tableicons from "../tableicons";
import Button from "@material-ui/core/Button";
import {withRouter} from "react-router";
import AnularTags from "./AnularTags";
import SnackbarAlert from "./SnackbarAlert";
import DialogEliminar from "./DialogEliminar";
import SearchIcon from "@material-ui/icons/Search";
import DialogExportar from "./DialogExportar";
import Grid from "@material-ui/core/Grid";
import SvgIcon from "@material-ui/core/SvgIcon";

class ListaTags extends React.Component{
    constructor(props) {
        super(props);
        if(props.tipo === 'contados'){
            this.state={
                open: false,
                datos: props.datos,
                columnas: props.columnas,
                tipo:props.tipo,
                seleccionar: false,
                selectedRow: null,
            }
        }
        if(props.tipo === 'espejos/mandatorios'){
            this.state={
                open: false,
                datos: props.datos,
                columnas: props.columnas,
                tipo:props.tipo,
                seleccionar: false,
                selectedRow: null,
            }
        }
        else if (props.tipo === 'forzados'){
            this.state={
                open: false,
                datos: props.datos,
                columnas: props.columnas,
                tipo:props.tipo,
                seleccionar: false,
                anular: false,
                motivo: "",
                openSnack:false,
                severity:"",
                message:"",
                desanular: false,
                content: "",
                title: "",
                selectedRow: null,
                eliminar:false,
                recuperar:false,
            }

        }
        else{
            this.state={
                open: false,
                datos: props.datos,
                columnas: props.columnas,
                tipo:props.tipo,
                seleccionar: true,
                seleccionados:[],
                anular: false,
                motivo: "",
                openSnack:false,
                severity:"",
                message:"",
                desanular: false,
                content: "",
                title: "",
                selectedRow: null,
                eliminar:false,
                recuperar:false,
            }
        }

    }

    desAnularTags = () =>{
       this.setState({desanular:true, title: "Des-anular tag/s", content: "Esta acción es irreversible. Está seguro que desea des-anular el/los tag/s?",})
    }

    eliminarForzados = ()=>{
        this.setState({eliminar:true, title: "Eliminar forzados", content: "Está seguro que desea eliminar todos los forzados?",})
    }

    recuperarForzados = ()=>{
        this.setState({recuperar:true, title: "Recuperar forzados", content: "Está seguro que desea recuperar todos los forzados?",})
    }

    refrescar=(estado,severity)=>{
        this.setState({recuperar:false,eliminar:false,anular: false, openSnack:false, severity: null, message:null, desanular:false, seleccionados:[], open:false});
        this.setState({openSnack:true, severity:severity, message:estado})
        this.props.refrescarTags()
    }

    refrescarExportar =(estado,severity) =>{
        this.setState({
            open: false,
            openSnack: true,
            message: estado,
            severity: severity})
    }

    enviarDatosReportes =(nombre)=>{
        let params = this.props.id_ubicacion
        let reporte = nombre
        this.setState({open: true, reporte: reporte, params: params,openSnack:false})
    }

    toolbarTipo = (props) =>{
        if(this.state.tipo === 'pendientes'){
            return(
                <div>
                    <MTableToolbar {...props} />
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                        <Grid item>
                            <Button variant="contained" color="primary" style={{margin:5}} disabled={this.state.seleccionados.length === 0} onClick={()=>this.setState({anular:true})}>
                                Anular seleccionado/s</Button>
                        </Grid>
                        <Grid>
                            <Button variant="contained" color="primary" style={{margin:5}} onClick={() => this.enviarDatosReportes("tags_pendientes")}>
                                Exportar {this.state.tipo}</Button>
                        </Grid>
                    </Grid>
                </div>
            )
        }
        else if(this.state.tipo === 'nulos'){
            return(
                <div>
                    <MTableToolbar {...props} />
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                        <Grid item>
                            <Button variant="contained" color="primary" style={{margin:5}} disabled={this.state.seleccionados.length === 0} onClick={this.desAnularTags}>
                                Des-anular seleccionado/s</Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" style={{margin:5}} onClick={() => this.enviarDatosReportes("tags_nulos")}>
                                Exportar {this.state.tipo}</Button>
                        </Grid>
                    </Grid>
                </div>
            )
        }
        else if(this.state.tipo === 'forzados'){
            return(
                <div>
                    <MTableToolbar {...props} />
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                        <Grid item>
                            <Button variant="contained" style={{margin:5}} color="primary" disabled={this.props.datos.length === 0} onClick={() => this.eliminarForzados()}>
                                Eliminar forzados
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" style={{margin:5}} color="primary" disabled={this.props.datos.length !== 0} onClick={() => this.recuperarForzados()}>
                                Recuperar forzados
                            </Button>
                        </Grid>
                       <Grid item>
                           <Button disabled={this.props.datos.length === 0} style={{margin:5}} variant="contained" color="primary" onClick={() => this.enviarDatosReportes("tags_forzados")}>
                               Exportar {this.state.tipo}</Button>
                       </Grid>
                    </Grid>
                </div>
            )
        }
        else if(this.state.tipo === 'forzados' || this.state.tipo === 'detalle_operador' ){
            return(
                <div>
                    <MTableToolbar {...props} />
                </div>
            )
        }
        else{
            return(
                <div>
                    <MTableToolbar {...props} />
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                        <Grid item>
                            <Button
                                startIcon={ <SvgIcon>
                                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                </SvgIcon>}
                                variant="contained" name="tags_nulos" color="primary" onClick={() => this.enviarDatosReportes("revision_por_tag")}>
                                Revisión por tag
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            )
        }
    }
    verDetalles = (rowData) =>{
        this.props.history.push("/detalles_tag/"+ rowData.id)
    }

    handleClose = () =>{
        this.setState({recuperar:false,eliminar:false,anular:false, desanular:false, open:false})
    }

    render() {
        return(
            <div>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                            nRowsSelected: "{0} tag(s) seleccionado(s)"
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense",
                        selection: this.state.seleccionar
                    }}
                    title=""
                    icons={tableicons}
                    data={this.props.datos}
                    columns={this.props.columnas}
                    actions={[
                        {
                            icon: () =>  <SearchIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Detalle',
                            onClick: (event, rowData) => this.verDetalles(rowData),
                            position: "row"
                        }
                    ]}
                    components={{
                        Toolbar: props => (
                            this.toolbarTipo(props)
                        ),
                    }}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    onSelectionChange={(rows) => this.setState({seleccionados:rows})}
                />
                {this.state.anular && <AnularTags refrescar={this.refrescar} handleClose={this.handleClose} tags={this.state.seleccionados}/>}
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.desanular && <DialogEliminar origen={"ListaTags"} handleClose={this.handleClose} refrescar={this.refrescar}
                                                         content={this.state.content} title={this.state.title} id={this.state.seleccionados}/>}
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.open? <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescarExportar} handleClose={this.handleClose}/> : null}
                {this.state.eliminar && <DialogEliminar origen={"Forzados"} handleClose={this.handleClose} refrescar={this.refrescar}
                                                         content={this.state.content} title={this.state.title} id={this.state.seleccionados}/>}
                {this.state.recuperar && <DialogEliminar origen={"RecuperarForzados"} handleClose={this.handleClose} refrescar={this.refrescar}
                                                        content={this.state.content} title={this.state.title} id={this.state.seleccionados}/>}
            </div>
        )
    }
}
export default withRouter(ListaTags);